import React, { ChangeEvent, SyntheticEvent, useMemo, useEffect, useRef, useState } from 'react'
import { Button, ButtonGroup, ButtonOr, Checkbox, Form, Grid, Header, Input, Segment, Select, TextArea } from 'semantic-ui-react'
import agent from '../../../app/api/agent'
import { debounce } from 'lodash'; 
import { v4 as uuid } from 'uuid';
import { DeliveryRequest, DeliveryRequestInitialState, ShippingRequest, ShippingRequestInitialState } from '../../../app/models/deliveryRequest';
import { toast } from 'react-toastify';
import { useStore } from '../../../app/stores/store';
import { HFCShipperInfo, HFCShipperInfoInitialdata } from '../../../app/models/ReceivingDelivery';
import { observer } from 'mobx-react-lite';
import { WorkFlowTemplate } from '../../../app/models/template';
import { historyInitialState } from '../../../app/models/history';
import { circuitCreationPOST } from '../../../app/api/types';
import axios from 'axios';


interface FormData {
  id: string;
  itemGroupId:string;
  title: string;
  asset_Id: string;
  print: string;
  vault: string;
  elementId: string;
}

function CustomerRequest() {
    const initialFormData: FormData = {
        id: '',
        itemGroupId: '',
        title: '',
        elementId: '',
        print: '',
        asset_Id: '',
        vault: ''
      };
    const{dashboardStore, userStore, activityStore, DeliveryStore} = useStore()
    const [options, setOptions] = useState<any[]>([]);
    const [titleSearch, setTitleSearch] = useState<any[]>([]);
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [notes, setNotes] = useState<string>('');
    const [address, setAddress] = useState<string>('');
    const [formData, setFormData] = useState<FormData>(initialFormData);
    const previousFormData = useRef<FormData>(formData);
    const [dateString, setDateString] = useState<string>('');
    const[finalShippingEditDate, setFinalShippingEditDate] =useState<string>('');
    const[finalReturnEditDate,setFinalReturnEditDate]=useState<string>('');
    const [returndateString, setReturnDateString] = useState<string>('');
    const [editDateClicked, setEditDateClicked] = useState(false);
    const [editReturnDateClicked, setEditReturnDateClicked] = useState(false);
    const[selectedLocation, setSelectedLocation]= useState<string>('')
    const[requestOptions, setRequestOptions]= useState<any[]>([])
    const[serviceOptions, setServiceOptions]= useState<any[]>([])
    const[selectedAccount, setSelectedaccount]= useState<string>('')
    const[selectedRequester, setSelectedRequester]= useState<string>(userStore.user?.displayName || '')
    const[selectedService, setSelectedService]= useState<string>('')
    const[selectedEmail,setSelectedEmail]=useState<string>(userStore.user?.email || '')
    const[shipper, setShipper]=useState<HFCShipperInfo>(HFCShipperInfoInitialdata)
    const [worflowTemplate, setWorflowTemplate] = useState<WorkFlowTemplate>();
    const[templateName,setTemplateName] =useState<string>('')
    const [ischecked, setIschecked] = useState<boolean>(false);



    function isSaveDisabled(formData:any, selectedEmail:any, selectedAccount:any, selectedLocation:any, address:any, notes:any) {
      const isFormDataEmpty = Object.values(formData).some(value => value === '');
      let areRequiredFieldsEmpty;
      if(dashboardStore.dashboard.valueForL3Orders === "Customer Service Request"){
        areRequiredFieldsEmpty = selectedEmail === "" || (ischecked && (selectedAccount === "" || selectedLocation === "" || address === "")) || selectedService === "";
      }else{
        areRequiredFieldsEmpty = selectedEmail === ""  || selectedAccount === "" || selectedLocation === "" || address === "";
      }
      return isFormDataEmpty || areRequiredFieldsEmpty;
    }
    const isShipperDisabled = templateName === ""
    
    const[shippingLocation, setShippingLocation]= useState<
    { key: string; value: string; text: string }[]
  >([]);
  const[accountOption, setAccountOption]= useState<
    { key: string; value: string; text: string }[]
  >([]);

  const[templateOptions, setTemplateOptions]= useState<
  { key: string; value: string; text: string }[]
>([]);

const debouncedTitleSearch = useMemo(
  () => debounce(async (value) => {
    if (value !== '') {
      try {
        const res = await agent.HFC.HFCtitleSearch(value);
        setTitleSearch(res.data);
        setDropdownOpen(true);
      } catch (error) {
        console.error('Error fetching title search results:', error);
      }
    }
  }, 500),
  [] // Empty dependency array ensures this is created once
);

// Handler for form input changes
const handleFormInputChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
  const { name, value } = e.target;
  
  if (name === 'title') {
    debouncedTitleSearch(value);
  }
  
  setFormData({ ...formData, [name]: value });
};

const loadAssetData = async (fieldName: keyof FormData, value: string) => {
  try {
    const res = await agent.HFC.HFClistAssetWAssetId(value);
    setOptions(res.data);

    const res2 = await agent.HFC.HFCAssetDetails(value);
    updateFormData(res2.data, fieldName);
  } catch (error) {
    console.error('Error fetching data:', error);
  }
};

    const handleNotesChange = (event: ChangeEvent<HTMLTextAreaElement>) => {
      setNotes(event.target.value);
    };

    useEffect(() => {
      const fetchData = async () => {
        if (activityStore.selectedShipper && 
          activityStore.selectedShipper.elementId !== "" &&
          dashboardStore.dashboard.valueForL3Orders === "Shipper") {
          setShipper(activityStore.selectedShipper);
          const res = await agent.HFC.HFCListTemplates(activityStore.selectedShipper.elementId);
          const tempOptions = res.data?.map((tName: any) => {
            return {
              key: tName.templateId,
              value: tName.templateId,
              text: tName.templateName,
            };
          });
          setTemplateOptions(tempOptions)
        }
      };
    
      fetchData();
       // eslint-disable-next-line
    }, [activityStore.selectedShipper]);
    
    
    useEffect(()=>{
      setFormData(initialFormData)
      // eslint-disable-next-line
    },[dashboardStore.dashboard.valueForL3Orders])
    useEffect(()=>{
      if(dashboardStore.dashboard.valueForL3Orders === "Customer Request" || dashboardStore.dashboard.valueForL3Orders==="Customer Service Request"){
      (async()=>{
        const response = await agent.HFC.HFCRequestedBy()
        const transformedOptions = response.data.map((user: { userName: any; email:any }) => ({
            key: user.email,
            text: user.userName,
            value: user.userName
          }));
          setRequestOptions(transformedOptions);
      })()  }
    // eslint-disable-next-line
    },[])

    useEffect(() => {
      if(dashboardStore.dashboard.valueForL3Orders === "Customer Request" || dashboardStore.dashboard.valueForL3Orders === "Customer Service Request"){
        (async () => {
          const response = await agent.WorkLevels.getMasterColumn({
            masterName: 'Theatre',
            componentName: 'Theatre Name',
            filterColumn: '',
            filterValue: '',
          });
          const tempOptions = response.data?.map((tName) => {
            return {
              key: tName,
              value: tName,
              text: tName,
            };
          });
          setShippingLocation(tempOptions);
        })();
      }
        // eslint-disable-next-line
      }, []);
    
      useEffect(() => {
      if(dashboardStore.dashboard.valueForL3Orders === "Customer Request" || dashboardStore.dashboard.valueForL3Orders === "Customer Service Request"){
        if (selectedLocation !== "") {
          (async () => {
            const response = await agent.WorkLevels.getMasterColumn({
              masterName: 'Theatre',
              componentName: 'Address',
              filterColumn: 'Theatre Name',
              filterValue: selectedLocation,
            });
            setAddress(response.data[0]); 
          })();
        }
      }
    // eslint-disable-next-line
      }, [selectedLocation]);

      useEffect(() => {
        if (address !== "" || shipper.address !== " ") {
          (async () => {
            const response = await agent.WorkLevels.getMasterColumn({
              masterName: 'Theatre',
              componentName: 'Account',
              filterColumn: 'Address',
              filterValue:shipper.address || shipper.theatreAddressLine1 || address,
            });
            const tempOptions = response.data?.map((tName) => {
                return {
                  key: tName,
                  value: tName,
                  text: tName,
                };
              });
              setAccountOption(tempOptions);
          })();
        }
      }, [address, shipper.address, shipper.theatreAddressLine1]);
      

    useEffect(() => {
        const getDate = new Date().toISOString().slice(0, 10).split('-'); 
        const _date = getDate[2] + '-' + getDate[1] + '-' + getDate[0];
        setDateString(_date); 
        setReturnDateString(_date)
        setFinalShippingEditDate(new Date().toISOString())
        setFinalReturnEditDate(new Date().toISOString())

      }, []);

      useEffect(() => {
        const fetchData = async (fieldName: keyof FormData) => {
          await loadAssetData(fieldName, formData[fieldName]);
        };

        const debouncedFetchData = debounce(fetchData, 600);

        let fetchCalled = false;

        for (const fieldName of specificKeys) {
          if (
            formData[fieldName] !== previousFormData.current[fieldName] &&
            formData[fieldName] !== ""
          ) {
            if (!fetchCalled) {
              debouncedFetchData(fieldName);
              fetchCalled = true;
            }
          }
        }

        previousFormData.current = formData;

        return () => {
          debouncedFetchData.cancel();
        };
        // eslint-disable-next-line
      }, [formData]);

      useEffect(() => {
        if (formData.elementId !== "" && dashboardStore.dashboard.valueForL3Orders === "Customer Service Request") {
          agent.HFC.HFCServiceRequest(formData.elementId)
            .then(res => {
              // Handle the response here
              const serviceOption = res.data.map((user: { templateId: any; templateName:any }) => ({
                key: user.templateId,
                text: user.templateName,
                value: user.templateName
              }));
              setServiceOptions(serviceOption);
            })
            .catch(error => {
              // Handle any errors that occur during the request
              console.error('Error fetching HFC service request:', error);
            });
        }
    // eslint-disable-next-line
      }, [formData.asset_Id, formData.print, formData.title]);
      
      
      const specificKeys: Array<keyof FormData> = ['asset_Id','print'];
      
      const enableCheck=()=>{
        setIschecked(prev=> !prev)
        if(ischecked){
          setSelectedLocation("");
          setAddress("");
          setSelectedaccount("");
        }
      }
      const handleDateChange = (e: any) => {
        //
        const getDate = new Date(e.target.value)
          .toISOString()
          .slice(0, 10)
          .split('-'); 
        const _date = getDate[2] + '-' + getDate[1] + '-' + getDate[0]; 
    
        setDateString(_date);
        // let getTime = new Date().toISOString().split('T')[1];
        const  dateValue = new Date(e.target.value)
        const currentTime = new Date();
        dateValue.setHours(currentTime.getHours());
        dateValue.setMinutes(currentTime.getMinutes());
        dateValue.setSeconds(currentTime.getSeconds());
        dateValue.setMilliseconds(currentTime.getMilliseconds());
        const newDateTime = dateValue.toISOString();
        setFinalShippingEditDate(newDateTime); //setting time with date
        setEditDateClicked(false);
      };

      const handleReturnDateChange = (e: any) => {
        const getDate = new Date(e.target.value)
          .toISOString()
          .slice(0, 10)
          .split('-'); 
        const _date = getDate[2] + '-' + getDate[1] + '-' + getDate[0]; 
    
        setReturnDateString(_date);
        const  dateValue = new Date(e.target.value)
        const currentTime = new Date();
        dateValue.setHours(currentTime.getHours());
        dateValue.setMinutes(currentTime.getMinutes());
        dateValue.setSeconds(currentTime.getSeconds());
        dateValue.setMilliseconds(currentTime.getMilliseconds());
        const newDateTime = dateValue.toISOString();
        setFinalReturnEditDate(newDateTime);
        setEditReturnDateClicked(false);
      };

    const updateFormData = (data: any, fieldName:any) => {
        if(fieldName === "title"){
            setFormData({
                ...formData,
                title: formData.title,
                asset_Id: data.asset_Id,
                vault: data.vault,
                print: data.print,
                id:data.id,
                itemGroupId:data.itemGroupId,
                elementId:data.elementId
            });
        }
        if(fieldName === "asset_Id"){
            setFormData({
                ...formData,
                title: data.title,
                asset_Id: formData.asset_Id,
                vault: data.vault,
                print: data.print,
                id:data.id,
                itemGroupId:data.itemGroupId,
                elementId:data.elementId
            });
        }
        if(fieldName === "print"){
            setFormData({
                ...formData,
                title: data.title,
                asset_Id: data.asset_Id,
                vault: data.vault,
                print: formData.print,
                id:data.id,
                itemGroupId:data.itemGroupId,
                elementId:data.elementId
            });
        }       
    };
    const handleSelectRequestChange = (event:any, data:any) => {
        const selectedValue = data.value;
        setSelectedRequester(selectedValue);
        const selectedUser = requestOptions.find(user => user.value === selectedValue);
        if (selectedUser) {
          setSelectedEmail(selectedUser.key);
        } else {
          setSelectedEmail('');
        }
      };

      const handleServiceRequestChange = async(event:any, data:any) => {
        const selectedValue = data.value;
        setSelectedService(selectedValue);
        const selectedTemplate = serviceOptions.find(user => user.value === selectedValue);
        if (selectedTemplate) {
          const res = await agent.HFC.HFCTemplateDetails(selectedTemplate.key);
          setWorflowTemplate(res.data)
        }
      };
    
   
      let optionsString = options.map(obj => {
        return Object.values(obj).join(', ') + ', '; 
      }).join('\n');

    const handleCancel = () => {
      if(dashboardStore.dashboard.valueForL3Orders === "Shipper"){
        setShipper(HFCShipperInfoInitialdata)
      }else{
        
        setFormData(initialFormData);
        setSelectedaccount('');
        setSelectedEmail('');
        setSelectedLocation('')
        setAddress('')
        setNotes('')
        setOptions([])
        setSelectedRequester('')
      }
      };
    const handleSave = async() =>{
      if(dashboardStore.dashboard.valueForL3Orders === "Shipper" || dashboardStore.dashboard.valueForL3Orders=== "Customer Service Request"){
        const updateUUIDs = (obj: any) => {
          if (Array.isArray(obj)) {
            obj.forEach((item: any) => {
              updateUUIDs(item);
            });
          } else if (typeof obj === 'object' && obj !== null) {
            if ('templateId' in obj) {
              obj.templateId = uuid();
            }
            if ('taskId' in obj) {
              obj.taskId = uuid();
            }
            if ('subTaskId' in obj) {
              obj.subTaskId = uuid();
            }
            if ('elementId' in obj) {
              obj.elementId = uuid();
            }
            if ('optionId' in obj) {
              obj.optionId = uuid();
            }
            for (let key in obj) {
              updateUUIDs(obj[key]);
            }
          }
        };
        updateUUIDs(worflowTemplate)
        await agent.HFC.HFCWorkflows(worflowTemplate)
        if(dashboardStore.dashboard.valueForL3Orders === "Shipper"){
        const payload={
          shippingId: shipper.id,
          templateId: worflowTemplate?.templateId,
          templateName: worflowTemplate?.templateName
        }
        const res =await agent.HFC.HFCAssignTask(payload)
        toast.success(res.data)
          const Pullpayload =  {
            ...historyInitialState,
            itemId: shipper.asset_ID,
            status: `${userStore.user?.displayName} has completed the shipper request for the asset "${activityStore.selectedShipper?.title}"`,
            dateTime: new Date().toISOString(),
            trackerFromTime: new Date().toISOString(),
          }
          await agent.HFC.HFCaddHistory(Pullpayload)
        // else{
        //   const Servicepayload =  { 
        //     ...historyInitialState,
        //     itemId: shipper.asset_ID,
        //     status: 'Service Request Completed'
        //   }
        //   await agent.HFC.HFCaddHistory(Servicepayload)
        // }
        dashboardStore.dashboard.valueForL3Orders = "Pull";
        }
        if(dashboardStore.dashboard.valueForL3Orders === "Customer Service Request"){
          const firstTask:any = worflowTemplate?.tasks
          firstTask.sort((a:any,b:any)=>a.taskIndex - b.taskIndex);
          const firstActiveTask = firstTask.find((task:any)=> task.isActive && !task.isDeleted);
          let assetDetail;
          try {
            const res = await agent.HFC.HFCAssetDetails(formData.title);
            assetDetail = res.data;
            if (!assetDetail) {
              toast.error("Asset details not found");
              return;
            }
          } catch (err) {
            toast.error("Error fetching asset details");
            return;
          }
          const Registerpayload ={
            templateId: worflowTemplate?.templateId,
            templateName: worflowTemplate?.templateName,
            firstService: firstActiveTask.taskName,
            external: ischecked
          }
          const commonId = uuid();
          const updatedActivityState: ShippingRequest = {
            ...ShippingRequestInitialState,
            id: commonId,
            asset_ID: formData.asset_Id,
            assetName: formData.title,
            print: formData.print,
            vault: formData.vault,
            elementId: formData.elementId,
            shipping_Date: finalShippingEditDate,
            return_Date: finalReturnEditDate,
            theatreName: selectedLocation,
            theatreAddressLine1: address,
            carrierAccount: selectedAccount,
            requestBy: selectedRequester,
            requesterEmailId: selectedEmail,
            associatedAssets: optionsString,
            notes,
            isCustomerRequestCompleted: true,
            templateName: worflowTemplate?.templateName || '',
            templateId: worflowTemplate?.templateId || '',
            taskAssignedDate: new Date().toISOString(),
            isShipperCompleted: false,
            requestType: selectedService || 'Service',
            customerName: "HFC Media Services",
            isActive: true,
            orderRequest: true,
            isCustomerServiceRequest: true,
            isAssigned: false,
            isExternal: ischecked,
            isServiceCompleted: false,
            isRetured: false,
            shippingAddress1: address,
            shippingCarrierAccount: selectedAccount,
          }

          const deliveryActivityState: DeliveryRequest = {
            ...DeliveryRequestInitialState,
            id: commonId,
            itemGroupId: assetDetail.itemGroupId,
            itemId: assetDetail.id,
            element: uuid(),
            assetName: formData.title,
            borrowerName: selectedAccount,
            borrowerAddress: address,
            borrowerEmail: selectedEmail,
            dateRequestRaised: new Date().toISOString(),
            dateOrderRegistered: new Date().toISOString(),
            dateOfDelivery: new Date().toISOString(),
            dateOfReturn: new Date().toISOString(),
            movementReason: selectedService || 'Service',
            movementType: worflowTemplate?.templateId || '',
            isApproved: true,
            account: selectedAccount,
            pickerName: userStore.user?.roleId as string,
            pickupBy: userStore.user?.customerName ?? 'HFC Media Services',
            isOrderCreated: true,
            isActive: true,
            orderRequest: true,
            isPickerAssigned: true,
            isBilled: true,
          }
          const getDateOnly = (isoString: string) => {
            return new Date(isoString).toISOString().slice(0, 10); // Returns 'YYYY-MM-DD'
          };
          const shippingDateOnly = getDateOnly(updatedActivityState.shipping_Date);
          const returnDateOnly = getDateOnly(updatedActivityState.return_Date);
          if(ischecked && shippingDateOnly === returnDateOnly) {
            return  toast.error("Delivery date and return date must not be the same. Please select different dates.");
          }
          const res = await agent.HFC.HFCRegisterCustomAsset(Registerpayload, updatedActivityState)
          const res2 = await axios.post(`/DeliveryRequest`, deliveryActivityState)
          const history =  {
            ...historyInitialState,
            itemId: formData.asset_Id,
            status: `${res.data}`,
            dateTime: new Date().toISOString(),
            trackerFromTime: new Date().toISOString(),
          }
          await agent.HFC.HFCaddHistory(history)
          if(res.data.includes('successfully')){
            const formatDate = (dateString: string): string => {
              const date = new Date(dateString.split('T')[0]);
              const day = String(date.getDate()).padStart(2, '0');
              const month = String(date.getMonth() + 1).padStart(2, '0');
              const year = date.getFullYear();
              return `${day}-${month}-${year}`;
          };
            toast.success(res.data)
            toast.success(res2.data)
            dashboardStore.dashboard.valueForL3Orders = "Assign Task to Personnal";
            const circuitPayload: circuitCreationPOST = {
              theater: updatedActivityState.theatreName,
              address: updatedActivityState.theatreAddressLine1,
              deliveryDate:  formatDate(updatedActivityState.shipping_Date),
              returnDate: formatDate(updatedActivityState.return_Date),
            };
            if(ischecked){
            DeliveryStore.circuitCreation({ itemId: updatedActivityState.asset_ID }, updatedActivityState.assetName, circuitPayload, false)
            }
          }else{
            toast.error(res.data)
            dashboardStore.dashboard.valueForL3Orders = "Customer Service Request"
          }
          // const payload =  {
          //   ...historyInitialState,
          //   itemId: formData.asset_Id,
          //   status: 'Customer Service Request',
          //   dateTime: new Date().toISOString(),
          //   trackerFromTime: new Date().toISOString(),
          // }
          // await agent.HFC.HFCaddHistory(payload)
        }
        activityStore.selectedShipper = HFCShipperInfoInitialdata
        setShipper(activityStore.selectedShipper)
      }else{
      const updatedActivityState: ShippingRequest = {
        ...ShippingRequestInitialState,
        id: uuid(),
        asset_ID: formData.asset_Id,
        assetName: formData.title,
        print: formData.print,
        vault: formData.vault,
        elementId: formData.elementId,
        shipping_Date: finalShippingEditDate,
        return_Date: finalReturnEditDate,
        theatreName: selectedLocation,
        theatreAddressLine1: address,
        carrierAccount: selectedAccount,
        requestBy: selectedRequester,
        requesterEmailId: selectedEmail,
        associatedAssets: optionsString,
        notes,
        isCustomerRequestCompleted: true,
        isShipperCompleted: false,
        isShippingCompleted: false,
        taskAssignedDate: new Date().toISOString(),
        requestType: "Shipping",
        customerName: "HFC Media Services",
        isActive: true,
        orderRequest: true,
        shippingAddress1: address,
        shippingCarrierAccount: selectedAccount,
        isCustomerServiceRequest: false,
        isAssigned: false,
        isExternal: false,
        isServiceCompleted: false,
        isRetured: false,
      }
      const getDateOnly = (isoString: string) => {
        return new Date(isoString).toISOString().slice(0, 10); // Returns 'YYYY-MM-DD'
      };
      const shippingDateOnly = getDateOnly(updatedActivityState.shipping_Date);
      const returnDateOnly = getDateOnly(updatedActivityState.return_Date);
      if(shippingDateOnly === returnDateOnly) {
        return  toast.error("Delivery date and return date must not be the same. Please select different dates.");
      }
      const res=await agent.HFC.HFCAssetRegister(updatedActivityState)
      if (res.data.includes("successfully")) {
        const formatDate = (dateString: string): string => {
          const date = new Date(dateString.split('T')[0]);
          const day = String(date.getDate()).padStart(2, '0');
          const month = String(date.getMonth() + 1).padStart(2, '0');
          const year = date.getFullYear();
          return `${day}-${month}-${year}`;
      };
        toast.success(res.data);
        dashboardStore.dashboard.valueForL3Orders = "Shipper";
        const circuitPayload: circuitCreationPOST = {
          theater: updatedActivityState.theatreName,
          address: updatedActivityState.theatreAddressLine1,
          deliveryDate:  formatDate(updatedActivityState.shipping_Date),
          returnDate: formatDate(updatedActivityState.return_Date),
        };
        DeliveryStore.circuitCreation({ itemId: updatedActivityState.asset_ID }, updatedActivityState.assetName, circuitPayload, false)
    } else {
       toast.error(res.data)
       dashboardStore.dashboard.valueForL3Orders = "Customer Request";       
    }
   
    // const payload =  {
    //   ...historyInitialState,
    //   itemId: formData.asset_Id,
    //   status: 'Customer Request Completed',
    //   dateTime: new Date().toISOString(),
    //   trackerFromTime: new Date().toISOString(),
    // }
    // await agent.HFC.HFCaddHistory(payload)
    handleCancel()
    }
    }
    const handleTemplateChange = async (event: React.ChangeEvent<HTMLSelectElement>, data: any) => {
      try {
        const selectedValue = data.value;
        const selectedtemp = templateOptions.find(temp => temp.value === selectedValue);
        if(selectedtemp){
        setTemplateName(selectedtemp?.key)
        }
        const res = await agent.HFC.HFCTemplateDetails(selectedValue);
        setWorflowTemplate(res.data)
      } catch (error) {
        console.error(error);
      }
    };

    const handleClick = async (data:any) => {
      const splitData = data.split(',');
      const selectedTitle = splitData[0];
      setFormData(prev => ({ ...prev, title: selectedTitle }));
      setDropdownOpen(false);
      await loadAssetData('title', selectedTitle);
    };
    const handleMouseEnter = (event:any) => {
      event.target.style.backgroundColor = 'lightgray';
    };
    
    const handleMouseLeave = (event:any) => {
      event.target.style.backgroundColor = 'white';
    };
    
  return (
    
    <div id="parent-grid-receiving">
    <Segment clearing className="register-form-segment ui clearing segment register-form-segment">
    <Form>
        <Header
            clearing
            icon="edit"
            size="huge"
            dividing
            as="h1"
            content="Customer Request Form"
            sub
            color="grey"
        />
        <Grid stretched columns={4} style={{marginTop: "10px"}}>
            <Grid.Column>
            <Form.Field style={{position: "relative"}}>
                <label className="mandatory-label">Title</label>
                <Input
                name="title"
                placeholder="Title"
                onChange={handleFormInputChange}
                value={dashboardStore.dashboard.valueForL3Orders === "Shipper" ? (shipper.title ?? shipper.assetName) : formData.title}
                readOnly={dashboardStore.dashboard.valueForL3Orders === "Shipper" ? true: false}
                />
               {
                  (dropdownOpen && titleSearch.length > 0) && (
                    <div style={{  maxHeight: '200px',  overflowY: 'auto',  marginTop:'10px',marginRight: '30px',position: 'absolute', zIndex: 10, backgroundColor: 'white', border: '1px solid rgba(34, 36, 38, .15)', borderRadius: '4px', width: '100%'}}>
                      {titleSearch.map((item:any, index:any) => (
                        <div key={index} style={{padding:'5px', cursor: 'pointer'}} onClick={() => handleClick(item.titles)} onMouseEnter={handleMouseEnter}
                        onMouseLeave={handleMouseLeave}>{item.titles}</div>
                      ))}
                    </div>
                  )
                }
            </Form.Field>
            
            </Grid.Column>
            <Grid.Column>
            <Form.Field>
                <label className="mandatory-label">Asset Id</label>
                <Input
                name="asset_Id"
                placeholder="Asset Id"
                onChange={handleFormInputChange}
                value={dashboardStore.dashboard.valueForL3Orders === "Shipper" ? shipper.asset_ID : formData.asset_Id}
                readOnly={dashboardStore.dashboard.valueForL3Orders === "Shipper" ? true: false}
                />
            </Form.Field>
            
            </Grid.Column>
            <Grid.Column>
            <Form.Field>
                <label className="mandatory-label">Print #</label>
                <Input
                name="print"
                placeholder="Print"
                onChange={handleFormInputChange}
                value={dashboardStore.dashboard.valueForL3Orders === "Shipper" ? shipper.print : formData.print}
                readOnly={dashboardStore.dashboard.valueForL3Orders === "Shipper" ? true: false}
                />
            </Form.Field>
            
            </Grid.Column>
            <Grid.Column>
            <Form.Field>
                <label className="mandatory-label">Vault</label>
                <Input
                name="vault"
                placeholder="Vault"
                value={dashboardStore.dashboard.valueForL3Orders === "Shipper" ? shipper.vault : formData.vault}
                readOnly={dashboardStore.dashboard.valueForL3Orders === "Shipper" ? true: false}
                />
            </Form.Field>
            
            </Grid.Column>
        </Grid>
        {dashboardStore.dashboard.valueForL3Orders === "Customer Service Request" ?
        <> {!ischecked ? null : 
        <Grid stretched columns={4}>
            <Grid.Column>
            {!editDateClicked ? (
                      <Form.Field
                        label= "Shipping Date"
                        placeholderText="Shipping Date"
                        value={ dateString}
                        control={Input}
                        onClick={() => setEditDateClicked(true)}
                        Icon="calendar alternate outline"
                        onKeyDown={(event: SyntheticEvent) => {
                          event.preventDefault();
                        }}
                      />
                    ) : (
                      <>
                        <label
                          style={{
                            marginBottom: '5px',
                            color: 'black',
                          }}
                        >
                          <b>Shipping Date</b>
                        </label>

                        <input
                          value={dateString}
                          type="date"
                          data-date=""
                          data-date-format="DD MMMM YYYY"
                          onChange={handleDateChange}
                        />
                      </>
                    )}
            </Grid.Column>
            <Grid.Column>
            <Form.Field>
                {!editReturnDateClicked ? (
                      <Form.Field
                        label= "Return Date"
                        placeholderText="Return Date"
                        value={returndateString}
                        control={Input}
                        onClick={() => setEditReturnDateClicked(true)}
                        Icon="calendar alternate outline"
                        onKeyDown={(event: SyntheticEvent) => {
                          event.preventDefault();
                        }}
                      />
                    ) : (
                      <>
                        <label
                          style={{
                            marginBottom: '5px',
                            color: 'black',
                          }}
                        >
                          <b>Return Date</b>
                        </label>

                        <input
                          value={returndateString}
                          type="date"
                          data-date=""
                          data-date-format="DD MMMM YYYY"
                          onChange={handleReturnDateChange}
                        />
                      </>
                    )}
            </Form.Field>
            
            </Grid.Column>
            <Grid.Column>
            <Form.Field
            required={true}
            name="shippingLocation"
            options={shippingLocation}
            control={Select}
            search
            clearable
            label="Shipping Location"
            placeholder="Select Location"
            onChange={(e:any, data:any) => {
              const selectedValue = data.value;
              setSelectedLocation(selectedValue)
            }
          }
            value={selectedLocation}
          />
            </Grid.Column>
            <Grid.Column>
            <Form.Field>
                <label className="mandatory-label">Address</label>
                <Input
                name="address"
                placeholder="Address"
                value={address}
                />
            </Form.Field>
            
            </Grid.Column>
        </Grid>
        }</> : <Grid stretched columns={4}>
            <Grid.Column>
            {!editDateClicked ? (
                      <Form.Field
                        label= "Shipping Date"
                        placeholderText="Shipping Date"
                        value={dashboardStore.dashboard.valueForL3Orders === "Shipper" ? shipper.shipping_Date: dateString}
                        readOnly={dashboardStore.dashboard.valueForL3Orders === "Shipper" ? true: false}
                        control={Input}
                        onClick={() => setEditDateClicked(true)}
                        Icon="calendar alternate outline"
                        onKeyDown={(event: SyntheticEvent) => {
                          event.preventDefault();
                        }}
                      />
                    ) : (
                      <>
                        <label
                          style={{
                            marginBottom: '5px',
                            color: 'black',
                          }}
                        >
                          <b>Shipping Date</b>
                        </label>

                        <input
                          value={dashboardStore.dashboard.valueForL3Orders === "Shipper" ? shipper.shipping_Date:dateString}
                          readOnly={dashboardStore.dashboard.valueForL3Orders === "Shipper" ? true: false}
                          type="date"
                          data-date=""
                          data-date-format="DD MMMM YYYY"
                          onChange={handleDateChange}
                        />
                      </>
                    )}
            </Grid.Column>
            <Grid.Column>
            <Form.Field>
                {!editReturnDateClicked ? (
                      <Form.Field
                        label= "Return Date"
                        placeholderText="Return Date"
                        value={dashboardStore.dashboard.valueForL3Orders === "Shipper" ? shipper.return_Date:returndateString}
                        control={Input}
                        onClick={() => setEditReturnDateClicked(true)}
                        Icon="calendar alternate outline"
                        readOnly={dashboardStore.dashboard.valueForL3Orders === "Shipper" ? true: false}
                        onKeyDown={(event: SyntheticEvent) => {
                          event.preventDefault();
                        }}
                      />
                    ) : (
                      <>
                        <label
                          style={{
                            marginBottom: '5px',
                            color: 'black',
                          }}
                        >
                          <b>Return Date</b>
                        </label>

                        <input
                          value={returndateString}
                          type="date"
                          data-date=""
                          data-date-format="DD MMMM YYYY"
                          onChange={handleReturnDateChange}
                          readOnly={dashboardStore.dashboard.valueForL3Orders === "Shipper" ? true: false}
                        />
                      </>
                    )}
            </Form.Field>
            
            </Grid.Column>
            <Grid.Column>
            <Form.Field
            required={true}
            name="shippingLocation"
            options={shippingLocation}
            control={dashboardStore.dashboard.valueForL3Orders === "Shipper" ? Input : Select}
            search
            clearable
            label="Shipping Location"
            placeholder="Select Location"
            onChange={(e:any, data:any) => {
              const selectedValue = data.value;
              setSelectedLocation(selectedValue)
            }
          }
          readOnly={dashboardStore.dashboard.valueForL3Orders === "Shipper" ? true: false}
            value={dashboardStore.dashboard.valueForL3Orders === "Shipper" ? (shipper.shipping_Location ?? shipper.theatreName) :selectedLocation}
          />
            </Grid.Column>
            <Grid.Column>
            <Form.Field>
                <label className="mandatory-label">Address</label>
                <Input
                name="address"
                placeholder="Address"
                value={dashboardStore.dashboard.valueForL3Orders === "Shipper" ? (shipper.address ?? shipper.theatreAddressLine1) : address}
                />
            </Form.Field>
            
            </Grid.Column>
        </Grid>
        }
        {
          dashboardStore.dashboard.valueForL3Orders !== "Customer Service Request" ?
          <Grid stretched columns={3}>
          <Grid.Column>
          <Form.Field
          required={true}
          name="account"
          options={accountOption}
          control={Select}
          search
          clearable
          label="Account"
          onChange={(e:any, data:any)=> setSelectedaccount(data.value)}
          readOnly={dashboardStore.dashboard.valueForL3Orders === "Shipper" ? true: false}
          value={dashboardStore.dashboard.valueForL3Orders === "Shipper" ? (shipper.account ?? shipper.carrierAccount):selectedAccount}
        />
          </Grid.Column>
          <Grid.Column>
          <Form.Field
          required={true}
          name="requestedBy"
          options={requestOptions}
          control={dashboardStore.dashboard.valueForL3Orders === "Shipper" ? Input : Select}
          search
          clearable
          label="Requested By"
          placeholder="Select requester"
          onChange={handleSelectRequestChange}
          readOnly={dashboardStore.dashboard.valueForL3Orders === "Shipper" ? true: false}
          value={dashboardStore.dashboard.valueForL3Orders === "Shipper" ? (shipper.requested_By ?? shipper.requestBy):selectedRequester}
        />
          </Grid.Column>
          <Grid.Column>
          <Form.Field>
              <label className="mandatory-label">Requester Email</label>
              <Input
              name="requester_email"
              placeholder="Requester Email"
              value={dashboardStore.dashboard.valueForL3Orders === "Shipper" ? (shipper.requester_Email ?? shipper.requesterEmailId):selectedEmail}
              />
          </Form.Field>
          
          </Grid.Column>
      </Grid>:<Grid stretched columns={!ischecked ? 2: 3}>
            {!ischecked ? null:
            <Grid.Column>
            <Form.Field
            required={true}
            name="account"
            options={accountOption}
            control={Select}
            search
            clearable
            label="Account"
            onChange={(e:any, data:any)=> setSelectedaccount(data.value)}
            value={selectedAccount}
          />
            </Grid.Column>}
            <Grid.Column>
            <Form.Field
            required={true}
            name="requestedBy"
            options={requestOptions}
            control={Select}
            search
            clearable
            label="Requested By"
            placeholder="Select requester"
            onChange={handleSelectRequestChange}
            value={selectedRequester}
          />
            </Grid.Column>
            <Grid.Column>
            <Form.Field>
                <label className="mandatory-label">Requester Email</label>
                <Input
                name="requester_email"
                placeholder="Requester Email"
                value={selectedEmail}
                />
            </Form.Field>
            
            </Grid.Column>
        </Grid>
        }
        
        <Grid stretched columns={2}>
            <Grid.Column>
                <Form.Field>
                    <label className="mandatory-label">Assets Associated  W/Title & Asset Id</label>
                    <TextArea  value={dashboardStore.dashboard.valueForL3Orders === "Shipper" ? shipper.assets_Associated_with_Title_and_Asset_ID:optionsString}/>
                </Form.Field>
            </Grid.Column>
            <Grid.Column>
                <Form.Field>
                    <label>Notes</label>
                    <TextArea value={dashboardStore.dashboard.valueForL3Orders === "Shipper" ? shipper.notes:notes} onChange={handleNotesChange}  />
                </Form.Field>
            </Grid.Column>
        </Grid>
        {
          dashboardStore.dashboard.valueForL3Orders === "Shipper" && (
          <>
            <Grid stretched columns={1}>
              <Grid.Column>
              <Form.Field
                required={true}
                options={templateOptions}
                control={Select}
                search
                clearable
                label="Assign Task To Personnel"
                placeholder="Assign Task"
                onChange={handleTemplateChange}
                value={templateName}
                />
              </Grid.Column>
            </Grid>
          </>
          )
        }
        {
          dashboardStore.dashboard.valueForL3Orders === "Customer Service Request" && (
          <>
            <Grid stretched columns={1}>
              <Grid.Column>
              <Form.Field
                required={true}
                options={serviceOptions}
                control={Select}
                search
                clearable
                label="Services"
                placeholder="Services"
                onChange={handleServiceRequestChange}
                value={selectedService}
                />
              <Checkbox label="External" defaultCheck={ischecked} onClick={enableCheck}/>
              </Grid.Column>
            </Grid>
          </>
          )
        }
        <div style={{textAlign: 'right', marginTop:'20px'}}>
        <ButtonGroup>
            <Button onClick={handleCancel}>Cancel</Button>
            <ButtonOr />
            <Button  disabled={dashboardStore.dashboard.valueForL3Orders !== "Shipper" ? isSaveDisabled(formData, selectedEmail, selectedAccount, selectedLocation, address, notes) : isShipperDisabled} positive onClick={handleSave}>Save</Button>
        </ButtonGroup>
        </div>
    </Form>
    </Segment>
    </div>
  )
}

export default observer(CustomerRequest)
